var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBuyCartIcon = function SvgBuyCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.073 2.929A9.97 9.97 0 0 0 10 0a9.97 9.97 0 0 0-7.072 2.929h-.003A9.966 9.966 0 0 0 0 10a9.966 9.966 0 0 0 2.926 7.071h.003A9.97 9.97 0 0 0 10 20a9.97 9.97 0 0 0 7.072-2.929h.003A9.966 9.966 0 0 0 20 10a9.966 9.966 0 0 0-2.925-7.071h-.003Z",
    fill: "#40B6C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.176 10.874a.867.867 0 0 1 1.128-1.318l1.672 1.43 3.664-3.765a.867.867 0 0 1 1.244 1.21l-4.232 4.348a.867.867 0 0 1-1.185.054l-2.29-1.96Z",
    fill: "#fff"
  })));
};
export default SvgBuyCartIcon;